// apiurl
const api = require("./config/api");
$.extend({ api });
//
require("./modules/noCopy/index.js"); //禁止页面复制(正式环境)
require("./modules/link/index.js"); //禁止href为空的链接被点击
require("./modules/copyRight/index.js"); //技术支持相关
require("./modules/numAnimat/index.js"); //数字跳动显示
require("./modules/subHeader/index.js"); // 子页面导航
//
require("./modules/clearCache/index.js"); //清除缓存
require("./modules/serverRestart/index.js"); //重启服务(正式环境生效 点击按钮后 在服务器上执行pm2 restart cjm-home)
//
require("./modules/superCodeCloud/index.js"); //超级玛云
require("./modules/imgLazyLoading"); //图片延迟加载
require("./modules/baiduStatistics"); //百度统计/在线咨询
require("./modules/home"); //首页相关的一些js
require("./modules/aboutUs"); //关于我们相关的js
require("./modules/industryApplication"); //行业应用相关的js
require("./modules/help"); //帮助中心相关的js
require("./modules/digitThreeAgriculture"); //数字三农相关的js
require("./modules/superFarmCode"); //超农码相关的js
require("./modules/login/index.js"); //登录相关的js
require("./modules/iot"); //登录相关的js
require("./modules/app"); //登录相关的js
require("./modules/public"); //公共返回顶部相关的js
require("./modules/develop"); //农业前沿相关的js

require("./modules/appHeader/index.js"); // app子页面导航
